module.exports = __webpack_public_path__ + "static/media/youtube.cca6e4f9.svg";